export default "__VITE_ASSET__d905fe35__"